import ApiService from "../../common/api.service";
import Vue from "vue";

const state = {
  all: [],
  cache: {}
};

// getters
const getters = {
  getCustomer: state => id => {
    return state.all[state.cache[id]];
  },
  getAll: state => {
    return state.all;
  }
};

// actions
const actions = {
  addCustomer(context, customer) {
    return new Promise((resolve, reject) => {
      ApiService.post("/customers", customer)
        .then(response => {
          context.commit("ADD", response.data);
          context.dispatch("loadCustomers");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  update(context, customer) {
    return new Promise((resolve, reject) => {
      ApiService.put("/customers/" + customer.id, customer)
        .then(response => {
          context.commit("UPDATE", response.data);
          context.dispatch("loadCustomers");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  loadCustomers(context) {
    ApiService.get("/customers").then(response => {
      context.commit("SET", response.data);
    });
  },
  delete(context, item) {
    return new Promise((resolve, reject) => {
      ApiService.delete("/customers/" + item.id)
        .then(() => {
          context.commit("DEL", item);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendSms(context, item) {
    return ApiService.post("/customers/" + item.id + "/sms", item);
  },
  export() {
    return new Promise(resolve => {
      ApiService.query("/export", { params: { type: "customer" } }).then(
        response => {
          resolve(response);
        }
      );
    });
  }
};

// mutations
const mutations = {
  ADD(state, item) {
    state.all.push(item);
    state.cache[item.id] = state.all.length - 1;
  },
  SET(state, items) {
    state.all = items;
    createCache(items);
  },
  UPDATE(state, item) {
    const index = state.cache[item.id];
    Vue.set(state.all, index, item);
  },
  DEL(state, item) {
    state.all.splice(state.cache[item.id], 1);
  }
};

function createCache(items) {
  for (let i = 0; i < items.length; i++) {
    state.cache[items[i].id] = i;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
